import React, {createContext} from 'react';

import type {ImmersiveOnboardingResult} from 'common/report/queries/app-api/immersive-onboarding';
import {CurrentProjectResource} from 'common/report/model-resources/projects';
import {CurrentUserResource} from 'common/report/model-resources/users';

export enum Step {
  Welcome = `welcome`,
  Events = `events`,
  Implement = `implement`,
  Explore = `explore`,
}

export type CompleteStep = {
  [key in Step]?: boolean;
};

export type CheckIntegrationResult = {is_integrated: boolean};

export const SetupGuideContext = createContext<{
  modalManager: {
    openModal: () => void;
    closeModal: () => void;
  };
  step: Step;
  setStep: React.Dispatch<React.SetStateAction<Step>>;
  setupGuideInfo: ImmersiveOnboardingResult;
  setSetupGuideInfo: React.Dispatch<React.SetStateAction<ImmersiveOnboardingResult>>;
  isIntegrated: boolean;
  setIsIntegrated: React.Dispatch<React.SetStateAction<boolean>>;
  completed: CompleteStep;
}>(null);

export const VisibilityContext = createContext<{
  visibility: boolean;
  setVisibility: React.Dispatch<React.SetStateAction<boolean>>;
}>(null);

export const AppContext = createContext<{
  currentProject: CurrentProjectResource;
  currentUser: CurrentUserResource;
}>({currentProject: null, currentUser: null});

export type BreakdownType = `device_type` | `country` | `os`;

export type BreakdownPreviewProps = {events: string[]; property: BreakdownType};
